import Numeral from "numeral";
import { useState } from "react";
import { useTranslation } from "next-i18next";
import { useCartContext } from "ab-context-cart";
import Text from "ab-text";
import QuantityPicker from "ab-quantity-picker";

const CartItem = ({ itm, i18n }) => {
  const [state, dispatch] = useCartContext();
  const { handleQtyChange, handleQtyChangePersonalizacion } = dispatch;
  // console.log("CartItem", itm);
  const [stockError, setStockError] = useState(false);

  if (Numeral.locales["abadia"] === undefined) {
    Numeral.register("locale", "abadia", {
      delimiters: {
        thousands: ".",
        decimal: ",",
      },
      abbreviations: {
        thousand: "k",
        million: "mm",
        billion: "b",
        trillion: "t",
      },
      ordinal: function(number) {
        var b = number % 10;
        return b === 1 || b === 3
          ? "er"
          : b === 2
          ? "do"
          : b === 7 || b === 0
          ? "mo"
          : b === 8
          ? "vo"
          : b === 9
          ? "no"
          : "to";
      },
      currency: {
        symbol: "€",
      },
    });
  }

  Numeral.locale("abadia");
  const { t } = useTranslation("common", { i18n });

  const getLanguageName = (name) => {
    if (name?.toLowerCase() == "añada") {
      return t("anada");
    } else if (name?.toLowerCase() == "formato") {
      return t("formato");
    } else {
      return name;
    }
  };
  const isPersonalizacion = itm?.product?.node?.sku?.includes("00605");
  const isEBox = itm?.product?.node?.sku?.includes("EB0");
  const addedItemsString =
    itm?.extraData?.length && itm?.extraData[0]?.value
      ? JSON.parse(itm?.extraData[0]?.value).find(
          (itm) => itm.name == "Que incluye"
        )?.value
      : "";
  const addedItems = addedItemsString ? addedItemsString.split(",") : [];

  const personalizacion =
    itm?.extraData?.length && itm?.extraData[0]?.value
      ? JSON.parse(itm?.extraData[0]?.value).find(
          (itm) => itm.name == "Texto para la etiqueta"
        )?.value
      : "";
  const tarjeton =
    itm?.extraData?.length && itm?.extraData[0]?.value
      ? JSON.parse(itm?.extraData[0]?.value).find(
          (itm) => itm.name == "Añadir una tarjeta personalizada"
        )?.value
      : "";

  // console.log("addedItems", addedItems);

  return (
    <>
      <div className="cart-item">
        <div className="image">
          <img src={itm?.product?.node?.image?.mediaItemUrl} />
        </div>
        <div className="details">
          <Text element="h3">{itm?.product?.node?.name}</Text>
          {itm?.product?.node?.attributes?.nodes ? (
            <Text element="span" className="title">
              {/* {itm?.product?.node?.attributes?.nodes
                .map((itm, index) =>
                  itm.options[0] !== "No Definido"
                    ? `${index == 0 ? "" : " "}${getLanguageName(itm.name)} ${
                        itm.options[0]
                      }`
                    : null
                )
                .filter(Boolean)} */}
            </Text>
          ) : null}
          {isEBox ? (
            <Text element="p" style={{ fontSize: 11 }}>
              EXPERIENCE BOX
            </Text>
          ) : null}
          {isEBox && addedItems?.length ? (
            <div className="adicionales">
              <Text element="p" className={"complementos"}>
                {t("queIncluye")}
              </Text>
              {addedItems.map((itm, index) => (
                <Text element="span" style={{ fontSize: 13 }}>
                  {itm}
                </Text>
              ))}
            </div>
          ) : null}
          {personalizacion || tarjeton ? (
            <>
              <Text element="p" className={"gold"}>
                {t("queIncluye")}
              </Text>
              <Text
                element="span"
                style={{
                  fontSize: 13,
                  lineHeight: 1.3,
                  fontFamily: "GT Eesti",
                  fontWeight: 300,
                }}
              >
                {`${t("personalizacion")}: <strong>${personalizacion}</strong>`}
              </Text>
              {tarjeton ? (
                <Text
                  element="span"
                  style={{
                    fontSize: 13,
                    lineHeight: 1.3,
                    fontFamily: "GT Eesti",
                    fontWeight: 300,
                    marginTop: 5,
                  }}
                >
                  {`${t("tarjeton")}:  <strong>${tarjeton}</strong>`}
                </Text>
              ) : null}
            </>
          ) : null}
          <div className="row">
            {" "}
            {isEBox ? (
              <div className="link"></div>
            ) : (
              <QuantityPicker
                quantity={itm.quantity}
                setQuantity={async (e) => {
                  let tempExtraData = itm?.extraData?.[0].value;
                  if (tempExtraData) {
                    tempExtraData = JSON.parse(tempExtraData);
                  }
                  // console.log("extraData", itm?.extraData?.[0], tempExtraData);
                  if (
                    parseInt(e) <=
                      parseInt(itm?.product?.node?.stockQuantity) ||
                    itm.quantity > e ||
                    !itm?.product?.node?.manageStock
                  ) {
                    console.log(
                      "handleQtyChange - cartItem",
                      itm,
                      itm.quantity,
                      e
                    );
                    await handleQtyChange(
                      itm,
                      e,
                      null,
                      JSON.stringify({ addons: tempExtraData })
                    ).then(async () => {
                      if (personalizacion && e == 0) {
                        await handleQtyChangePersonalizacion(itm, -1, null);
                      }
                    });

                    setStockError(false);
                  } else {
                    setStockError(true);
                  }
                }}
                allowZero
                disabled={isPersonalizacion}
                i18n={i18n}
              />
            )}
            <Text element="h4">
              {`${Numeral(
                itm?.extraData?.[0].value != "[]"
                  ? Numeral(itm.subtotal).value() +
                      Numeral(itm.subtotalTax).value()
                  : Numeral(itm?.product?.node?.price).value() * itm.quantity
              ).format("1,000.00$")}`}
            </Text>
          </div>

          {stockError ? (
            <div className="stock-error-text">{t("no-hay-stock")}</div>
          ) : null}
          {!isPersonalizacion ? (
            <button
              onClick={async () =>
                await handleQtyChange(itm, -itm?.quantity).then(async () => {
                  if (personalizacion) {
                    await handleQtyChangePersonalizacion(
                      itm,
                      -itm?.quantity,
                      null
                    );
                  }
                })
              }
            >
              X
            </button>
          ) : null}
        </div>
      </div>
      {/* para mobile */}
      {isEBox && addedItems?.length ? (
        <div className="adicionales-mobile">
          <Text element="p" className={"complementos"}>
            {"¿Qué incluye?"}
          </Text>
          {addedItems.map((itm, index) => (
            <Text element="span" style={{ fontSize: 13 }}>
              {itm}
            </Text>
          ))}
        </div>
      ) : null}
      {isEBox ? (
        <div className="info">
          <img src="/images/info.png" width={20} height={20} />
          <div className="row">
            <Text
              element="span"
              style={{
                fontSize: 11,
                color: "#a79669",
                fontFamily: "GT Eesti",
                fontWeight: 300,
              }}
            >
              {t("infobeneficiario")}
            </Text>
          </div>
        </div>
      ) : null}
    </>
  );
};

export default CartItem;
